<template>
    <div>
        <language-dropdown></language-dropdown>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-xl-10 col-lg-12 col-md-9">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <div class="container">
            <common-footer-buttons></common-footer-buttons>
        </div>
    </div>
</template>
<script>
import LanguageDropdown from './partials/LanguageDropdown';
import CommonFooterButtons from './partials/CommonFooterButtons.vue';

export default {
    components: {
        'common-footer-buttons': CommonFooterButtons,
        'language-dropdown': LanguageDropdown
    },
}
</script>

<style lang="scss">
    
</style>